module.exports = __webpack_public_path__ + "static/media/team-tyler.9f5a7c41.jpg";